<template>
  <errorContainer :error="erreur" :warning="warning">
    <div class="animated fadeIn">
      <div class="form">
        <div v-if="$screen.width <= 576" class="my-expense-mobile">
          <div class="title">
            <h1 class="main-page-title" :class="{ 'is-pwa': $isPwa() }">
              {{ FormMSG(1, 'My invoices') }}
            </h1>
          </div>
          <div class="my-expense-actions" :class="{ 'pt-16': $isPwa() }">
            <div class="d-flex justify-content-start title-add mt-2">{{ FormMSG(56, 'Add Invoice') }}</div>
            <div class="d-flex justify-content-center wapper">
              <div class="btn-action text-center" @click="handleNewInvoice(true)">
                <img src="svgs/invoice.svg" alt="new Invoice" />
                <span class="px-2">{{ FormMSG(2, 'New Invoice') }}</span>
              </div>
            </div>
          </div>
        </div>
        <b-row v-if="$screen.width >= 576" align-h="between">
          <b-col sm="4">
            <h1>{{ FormMSG(1, 'Invoices') }}</h1>
          </b-col>
          <b-col sm="8" class="text-right">
            <b-button size="md" variant="success" class="mr-2" @click="handleNewInvoice(true)">
              <component :is="getLucideIcon('Plus')" :size="20" class="mr-2" />
              <span>{{ FormMSG(2, 'New Invoice') }}</span>
            </b-button>
            <b-button
              v-if="showSendValidationBtnEfc"
              size="md"
              variant="light"
              class="text-light"
              :class="!activeDraftAction || selectedInvoiceHasRefusedItem ? 'bgc-slate-light' : 'btn-custom-blue-dark'"
              :disabled="!activeDraftAction || selectedInvoiceHasRefusedItem"
              @click="sendForApproval(selectedInvoice)"
            >
              <component :is="getLucideIcon('Send')" :size="20" class="mr-2" />
              <span>{{ FormMSG(8, 'Send for approval') }}</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <div class="d-flex flex-column w-100">
            <b-card no-body :class="`${$screen.width <= 576 ? 'my-project' : ''}`">
              <b-tabs v-model="tabs.activeTabs" @activate-tab="(n, p, e) => onTabClicked(n)">
                <b-tab lazy :title="FormMSG(4, 'Invoices')">
                  <div class="pr-1 pl-1 w-100">
                    <invoices-data-view
                      :key="draftDataKey"
                      ref="draftDataView"
                      for-efc-draft
                      can-see-crew-member
                      not-submitted-state
                      @selection:change="(n, e) => invoiceSelectionChange(n, e)"
                      @open:details="(e) => showInvoiceDetails(e, true, false, true, false, true)"
                      @approveInvoice="(e) => approveSelected(e)"
                      @sendInvoiceForApproval="(e) => sendForApproval(e)"
                    />
                  </div>
                </b-tab>
                <b-tab lazy :title="FormMSG(5, 'Submitted invoices')">
                  <div class="pr-1 pl-1 w-100">
                    <invoices-data-view
                      ref="submittedDataView"
                      for-efc-submitted
                      can-see-crew-member
                      submitted-state
                      @open:details="(e) => showInvoiceDetails(e, false, false, true, false, true)"
                    />
                  </div>
                </b-tab>
              </b-tabs>
            </b-card>
          </div>
        </b-row>
      </div>
    </div>
    <dialog-container
      ref="dragAndDropDialog"
      :show="openDragAndDropDialog"
      :dialog-title="dragAndDropDialogInfo.title"
      :btn-close-label="dragAndDropDialogInfo.closeLabel"
      :btn-save-label="dragAndDropDialogInfo.saveLabel"
      size="lg"
      :centered="true"
      :enable-next-or-save="ableToSwitchFinalForm"
      :disable-canel-or-close="filesUploadInProgress"
      @close="closeDragAndDropDialog(true)"
      @nextOrSave="nextOrSaveProcess"
    >
      <template #content>
        <div :class="{ 'mt-4 mx-3': maxMobileScreenWidth, 'mx-5': !maxMobileScreenWidth }">
          <div class="d-flex" :class="maxMobileScreenWidth ? 'flex-column justify-content-start' : 'flex-row justify-content-between'">
            <div class="col-12 col-sm-6 col-md-6" :class="maxMobileScreenWidth ? 'p-0' : 'p-2 '">
              <b-form-checkbox v-model="isWithDetails" size="lg" plain>{{ FormMSG(53, 'with details') }}</b-form-checkbox>
            </div>
            <div class="d-flex">
              <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                  v-model="isForSingle"
                  :options="invoiceModeOptions"
                  :aria-describedby="ariaDescribedby"
                  :disabled="filesUploadInProgress"
                  class="text-right my-2"
                  name="radio-inline"
                  plain
                  @change="preventChoiceIfInvoicesNotEmpty"
                ></b-form-radio-group>
              </b-form-group>
            </div>
          </div>
          <b-row class="pb-4">
            <b-col sm="12">
              <b-form-group>
                <template #label>
                  <label>{{ FormMSG(70, 'Select Person') }}</label>
                  <span class="text-danger"><strong> *</strong></span>
                </template>
                <v-select
                  v-model="userToEncodedId"
                  class="w-100"
                  :placeholder="FormMSG(6, 'Select a person')"
                  :options="users"
                  label="name"
                  :reduce="(option) => option.value"
                  @input="handleSelectUser"
                ></v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <files-uploader
            :disable-type-change="filesUploadInProgress"
            :files-list="currentProcessFiles"
            :for-single="isForSingle"
            @add="(e) => onAddFiles(e, true, true)"
            @remove="onRemoveFiles"
          />
        </div>
      </template>
    </dialog-container>
    <dialog-container
      ref="multipleInvoiceDialog"
      :show="openMultipleInvoiceDialog"
      :dialog-title="multipleInvoiceDialogInfo.title"
      :btn-close-label="multipleInvoiceDialogInfo.closeLabel"
      :btn-save-label="multipleInvoiceDialogInfo.saveLabel"
      size="xxl"
      :centered="false"
      :show-save-button="false"
      @close="closeMultipleInvoice(true)"
    >
      <template #content>
        <invoices-data-view
          v-if="openMultipleInvoiceDialog"
          ref="multiple-data-view"
          for-multiple-invoice
          :loading-review-mode="isReviewModeLoading"
          :invoice-list="invoices"
          submitted-state
          @selection:change="(n, e) => invoiceSelectionChange(n, e)"
          @open:details="(e) => showInvoiceDetails(e, (canEdit = true), (isNewProcess = true), (isForSingle = false), (reviewMode = false), (isForEfc = true))"
          @open:review-mode="(e) => openReviewMode(e, (newProcess = true), (isForEfc = true))"
          @row:delete="removeInvoicesFromDataView"
        />
      </template>
    </dialog-container>
    <dialog-invoice-details
      ref="dialogInvoiceDetails"
      :invoice="currentInvoice"
      :is-new-creation="isNewProcess"
      :total-invoices-to-review="invoicesToReview.length"
      :index-to-review="currentIndexToReview"
      use-script-expense-report-invoice
      @dialog-invoice:close="handleFinsihCloseOrCancelProcess('close', true)"
      @dialog-invoice:prev="onPrevOrNext(false, true)"
      @dialog-invoice:next="onPrevOrNext(true, true)"
    >
      <template #form-title>{{ finalFormDialogInfo.title }}</template>
      <template #form-content>
        <invoices-form
          ref="invoiceFinalForm"
          :invoice-data="currentInvoice"
          :tax-options-invoice="taxOptions"
          :custom-flags-invoice="customFlags"
          :can-edit="canEditFinalForm"
          :all-invoice-categories="allCategories"
          :is-new-creation="isNewProcess"
          :initial-operation="initialItemsOperation"
          @enable:save="(e) => (enableFinalSaveBtn = e)"
          @enable:error="(e, n) => showErrorMessage(e, n)"
          @delete:item="(item, index, itemsCurrentState, flagsCurrentState) => deleteLineItemsRow(item, index, itemsCurrentState, flagsCurrentState)"
          @submit:form="(invoice, itemsOperation) => nextOrSaveFromFinal(invoice, itemsOperation, true)"
          @file:uploaded="(file) => uploadFile(file)"
          @file:remove="(file) => removeAdditionalInvoiceFile(file)"
        />
      </template>
      <template #form-error-message>{{ finalFormDialogError }}</template>
      <template #form-close-label>{{ isSavedOnce ? dialogMsg.btnClose : finalFormDialogInfo.closeLabel }}</template>
      <template #form-footer-action-right-btn>
        <b-button v-if="canEditFinalForm" size="md" variant="primary" class="w-138-px mr-3" :disabled="!enableFinalSaveBtn" @click="saveInvoice">
          <div style="gap: 7px" class="d-flex align-items-center justify-content-center">
            <b-spinner v-show="isSaving" small></b-spinner><span>{{ finalFormDialogInfo.saveLabel }}</span>
          </div>
        </b-button>
      </template>
    </dialog-invoice-details>
    <common-warning-on-delete
      ref="warningDialog"
      v-model="showDeleteWarning"
      :message="messageOnCancel"
      @dialog:cancel="showDeleteWarning = false"
      @dialog:confirm="handleFinsihCloseOrCancelProcess('cancel', true)"
    />
    <duplicate-expenses-warning
      v-model="showInvoiceDuplicatedAlert"
      :ocr-message-error="invoiceDuplicatedAlertMsg"
      @expenses-warning:ok="showInvoiceDuplicatedAlert = false"
    ></duplicate-expenses-warning>
    <!-- isWaitingOcrProcess data come from invoices.tools.mixin -->
    <dialog-waiting-ocr-invoice :show="isWaitingOcrProcess" @process:aborted="isWaitingOcrProcess = false" />
  </errorContainer>
</template>

<script>
// components
import InvoicesDataView from '@/views/myinvoices/components/InvoicesDataView';
import DialogContainer from '@/views/myinvoices/components/DialogContainer';
import FilesUploader from '@/views/myinvoices/components/FilesUploader';
import InvoicesForm from '@/views/myinvoices/components/InvoicesForm';
import CommonWarningOnDelete from '@/components/Dialogs/CommonWarningOnDeleteDialog';
import DialogInvoiceDetails from '@/views/myinvoices/components/DialogInvoiceDetails';
import DuplicateExpensesWarning from '@/components/Modals/DuplicateExpensesWarningModal';
import DialogWaitingOcrInvoice from '@/views/myinvoices/components/DialogWaitingOcrInvoice.vue';
// mixin
import globalMixin from '@/mixins/global.mixin';
import languageMessages from '@/mixins/languageMessages';
import isSingleProjectMixin from '@/mixins/isSingleProject.mixin';
import invoicesToolsMixin from '@/mixins/invoicesTools.mixin';

// cruds
import { getUsers } from '@/cruds/users.crud';

// store & utils
import { store } from '@/store';
import _ from 'lodash';

export default {
  name: 'InvoiceEntryCrew',
  components: {
    InvoicesDataView,
    DialogContainer,
    FilesUploader,
    InvoicesForm,
    CommonWarningOnDelete,
    DialogInvoiceDetails,
    DuplicateExpensesWarning,
    DialogWaitingOcrInvoice
  },
  mixins: [languageMessages, isSingleProjectMixin, globalMixin, invoicesToolsMixin],
  data() {
    return {
      // for users list
      users: [{ value: null, name: 'Select ...' }]
    };
  },
  computed: {
    showSendValidationBtnEfc() {
      return this.tabs.activeTabs === 0;
    },
    ableToSwitchFinalForm() {
      if (this.invoices.length > 0 && this.userToEncodedId) {
        return this.isStepToFinalFormFulfilled();
      } else return false;
    }
  },
  async created() {
    await this.getAllUsers();
  },
  methods: {
    async getAllUsers() {
      let forInvoice = true;

      const usersData = await getUsers({ myProject: true }, 0, -1, 0, 0, '', '', null, null, null, forInvoice);
      if (usersData) {
        this.userList = _.cloneDeep(usersData);
        this.users = [
          ...this.users,
          ...[...usersData].map((_user) => {
            return { value: _user.id, name: _user.fullName };
          })
        ];
      }
      const storageProfile = store.state.myProfile ? store.state.myProfile.id : 0;
      this.users = this.users.filter((item) => +item.value !== +storageProfile);
    },
    handleSelectUser(id) {
      const userData = this.provideUserToEncodeData(id);
      if (userData && this.invoices.length > 0) {
        this.invoices = _.cloneDeep(
          this.invoices.map((invoice) => ({
            ...invoice,
            ...userData
          }))
        );
      }
    }
  }
};
</script>

<style>
.no-padding {
  padding: 0 !important;
}
</style>
